import { render } from "./NamespaceRow.vue?vue&type=template&id=2f72e6c2&scoped=true"
import script from "./NamespaceRow.vue?vue&type=script&lang=js"
export * from "./NamespaceRow.vue?vue&type=script&lang=js"

import "./NamespaceRow.vue?vue&type=style&index=0&id=2f72e6c2&lang=scss&scoped=true"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f72e6c2"]])

export default __exports__